import { styled } from "@mui/material/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ClearIcon from "@mui/icons-material/Clear";

const SearchInputMain = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  background: "#FFFFFF",
  border: "1px solid #E8E8E8",
  height: "40px",
  padding: "0px 7px",
  "& img": { marginRight: "5px" },
  "& input": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "16px",
    color: "rgba(30, 39, 56, 0.5)",
    border: "none",
    width: "100%",
    height: "100%",
    "&:focus": { border: "none", outline: "none" },
  },
}));

const SearchButton = styled(ArrowForwardIcon)(({ theme }) => ({
  fontSize: "20px",
  cursor: "pointer",
}));
const SearchClean = styled(ClearIcon)(({ theme }) => ({
  fontSize: "20px",
  cursor: "pointer",
}));

export { SearchInputMain, SearchButton, SearchClean };
